import React from 'react';

export const PageHeaderWithButton = ({ title, btnText, btnOnClick, forbidCreateNew }) => {
    return (
        <div className="row page-header">
            <div className="columns small-9">
                <h1 className="page__title">{title}</h1>
            </div>
            <div className="columns small-3 button-wrapper">
                <button type="button" disabled={forbidCreateNew} className="button large expanded" onClick={btnOnClick}>{btnText}</button>
            </div>
        </div>
    );
}